module.exports = __webpack_public_path__ + "media/images/lb/020-a6b9b37134df2370387e8b049b136401.svg";